import { render, staticRenderFns } from "./lcpz.vue?vue&type=template&id=94bb3ade&scoped=true&"
import script from "./lcpz.vue?vue&type=script&lang=js&"
export * from "./lcpz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bb3ade",
  null
  
)

export default component.exports